// CoreUI Pro source reference: /Users/guochunzhong/git/oss/coreui-pro/js/src/date-picker.js
import DateRangePicker from "./date-range-picker"

export default class DatePicker extends DateRangePicker {
  static componentName = "date-picker"
  static defaults = {
    ...DateRangePicker.defaults,
    calendars: 1,
    placeholder: ["Select date"],
    range: false,
    separator: false,
  }
}
